/*
 * @Author: your name
 * @Date: 2021-05-14 16:02:59
 * @LastEditTime: 2022-04-06 10:31:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/apps/modules/qc-plan/moduleDefine.js
 */
/* BasicLayout */
import BasicLayout from '@/frameworks/layouts/BasicLayout'
import { dynamicWrapper } from '@/common/utils/routerComponentWrapper.js'
const routerComponents = {
  workBench: () => import('./my-work-bench/index.vue'),
  myInfo: () => import('./my-info/index.vue'),
  reportGk: () => import('./report-gk/index.vue')
}

export default {
  // 模块子路由表
  routes: [
    {
      path: '/',
      component: BasicLayout,
      meta: {
        title: '质量管理工作台',
        icon: 'chart'
      },
      children: [
        {
          path: 'GZT/GZTList',
          component: dynamicWrapper(
            ['qc-workBench/my-work-bench'],
            routerComponents.workBench
          ),
          meta: { title: '工作台', noCache: true }
        },
        {
          path: 'GZT/MyInfo',
          component: dynamicWrapper(
            ['qc-workBench/my-info'],
            routerComponents.myInfo
          ),
          meta: { title: '我的质控信息', noCache: true }
        },
        {
          path: 'GZT/NqcSummary',
          component: dynamicWrapper(
            ['qc-workBench/report-gk'],
            routerComponents.reportGk
          ),
          meta: { title: '数据概况', noCache: true }
        }
      ]
    }
  ]
}
